import React from 'react';
import SEO from "../components/seo";

const About = () => {
  return (
    <>
     <SEO page="about" />
<main>
  {/* breadcrumb area start */}
  <section className="ca-breadcrumb-area cream-bg-3 p-relative z-index-1 fix">
    <div className="ca-breadcrumb-shape p-absolute bre-sh-1">
      <img
        src="/static/img/shape/breadcrumn-shape.webp"
        alt=""
      />
    </div>
    <div className="ca-breadcrumb-shape p-absolute bre-sh-2">
      <img
        src="/static/img/shape/ca-line-shape.webp"
        alt=""
      />
    </div>
    <div className="container">
      <div className="ca-breadcrumb-content text-center">
        <h2 className="ca-breadcrumb-title fnw-600">About Us</h2>
        <div className="it-breadcum-link">
          <a href="/">Home</a>
          <span>
            <i className="fa-solid fa-angle-right" />
          </span>
          <a className="active" href="#">
            About Us
          </a>
        </div>
      </div>
    </div>
  </section>
  {/* breadcrumb area end */}
  {/* about section start */}
  <section className="ca-about-3 pt-100 pb-70">
    <div className="container">
      <div className="row">
        <div className="col-lg-6 mb-30 hide-m">
          <div className="ca-ab-iner p-relative z-index-1">
            <div className="ca-iner-review-text p-absolute theme-bg-3">
              <h3 className="ca-counter-title fnw-700 pb-16">
                <span className="counter">750</span>+
              </h3>
              <span>Clients Positive Reviews</span>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6 mb-30">
                <div
                  className="ca-ab-iner-img wow img-custom-anim-left"
                  data-wow-duration="1.5s"
                  data-wow-delay=".2s"
                >
                  <img
                    className="w-100"
                    src="/static/img/about/ca-about1.1.webp"
                    alt=""
                  />
                </div>
              </div>
              <div className="col-lg-6 col-md-6 mb-30">
                <div
                  className="ca-ab-iner-img ca-ab-iner-img-2 wow img-custom-anim-left"
                  data-wow-duration="1.5s"
                  data-wow-delay=".4s"
                >
                  <img
                    className="w-100 mt-60"
                    src="/static/img/about/ca-about1.2.webp"
                    alt=""
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6 mb-30">
          <div className="ca-ab-content3">
            <div className="ca-about-content-3 ca-sec-content-3">
              <h5 className="ca-section-subtitle subtitle-bg-6 p-relative theme-color-3 br-50">
                Who We Are
              </h5>
              <h2 className="ca-section-title theme-black-3 fnw-600 pt-16 ca-text-cap">
              About Karmyogi Enterprise
              </h2>
              <p className="pt-16 pb-32 P-32">
                {" "}
                Karmyogi Enterprise is a professional and dedicated trading firm strategically positioned to fulfill the material needs of various industries. We specialize solely in sourcing, supplying, and distributing premium-grade copper pipes and fittings. Recognizing the importance of these components in systems such as HVAC, plumbing, gas lines, and industrial processes, we carefully vet our sources to ensure that every product we trade meets strict international quality and performance standards. Our goal is to provide reliable material solutions supported by efficient logistics and excellent service.
            
              </p>
              <h5>We are Specialised in:</h5><br />
            </div>
            <div className="ca-ab-item-check">
              {/* single-item */}
              <div className="ca-ab-sngle-item">
                <div className="ca-ab-sngle-item-ic">
                  <span>
                    <i className="fa-solid fa-check" />
                  </span>
                </div>
                <div className="ca-ab-sngle-item-content">
                  <h4 className="ca-item-ch-title">
                    Copper Fittings
                  </h4>
                </div>
              </div>
              {/* single-item */}
              <div className="ca-ab-sngle-item">
                <div className="ca-ab-sngle-item-ic">
                  <span>
                    <i className="fa-solid fa-check" />
                  </span>
                </div>
                <div className="ca-ab-sngle-item-content">
                  <h4 className="ca-item-ch-title">
                    Gas Fittings
                  </h4>
                </div>
              </div>
              {/* single-item */}
              <div className="ca-ab-sngle-item">
                <div className="ca-ab-sngle-item-ic">
                  <span>
                    <i className="fa-solid fa-check" />
                  </span>
                </div>
                <div className="ca-ab-sngle-item-content">
                  <h4 className="ca-item-ch-title">
                    Tube Fittings
                  </h4>
                </div>
              </div>
              {/* single-item */}
              <div className="ca-ab-sngle-item">
                <div className="ca-ab-sngle-item-ic">
                  <span>
                    <i className="fa-solid fa-check" />
                  </span>
                </div>
                <div className="ca-ab-sngle-item-content">
                  <h4 className="ca-item-ch-title">
                    Copper Pipes
                  </h4>
                </div>
              </div>
              {/* single-item */}
              <div className="ca-ab-sngle-item">
                <div className="ca-ab-sngle-item-ic">
                  <span>
                    <i className="fa-solid fa-check" />
                  </span>
                </div>
                <div className="ca-ab-sngle-item-content">
                  <h4 className="ca-item-ch-title">
                    Gas Copper Fittings
                  </h4>
                </div>
              </div>
              {/* single-item */}
              <div className="ca-ab-sngle-item">
                <div className="ca-ab-sngle-item-ic">
                  <span>
                    <i className="fa-solid fa-check" />
                  </span>
                </div>
                <div className="ca-ab-sngle-item-content">
                  <h4 className="ca-item-ch-title">
                    Gas Pipeline Products
                  </h4>
                </div>
              </div>
            </div>
            {/* <div className="ca-about-item3 cream-bg-3 p-relative">
              <p>
                We are driving success and creating opportunities for growth.
                Discover <br />
                difference with a logistics partner that is truly invested in
                your success.
              </p>
            </div> */}
            {/* <div className="ca-about-3-btn">
              <a
                href="#"
                className="ca-btn-primary-3 theme-bg-3 text-white br-50"
              >
                Transpires
                <span>
                  <i className="fa-solid fa-angle-right" />
                </span>
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* about section end */}
  {/* choose section start */}
  <section className="ca-about-3 cream-bg-3 pt-100 pb-70">
    <div className="container">
      <div className="row">
        <div className="col-lg-6 mb-30">
          <div className="ca-choose-content3">
            <div className="ca-about-content-3 ca-sec-content-3">
              <h5 className="ca-section-subtitle subtitle-bg-6 p-relative theme-color-3 br-50">
                Our Vision & Commitment
              </h5>
              <h2 className="ca-section-title theme-black-3 fnw-600 pt-16 ca-text-cap">
                Karmyogi Key Values
              </h2>
              {/* <p className="pt-16 pb-40">
                We pride ourselves on our global reach and local expertise,
                allowing us to offer tailored services that meet the unique
                needs of each client. At Cargon, we are <br /> not just moving
                goods; we are driving success and creating opportunities.
              </p> */}
            </div><br />
            <div className="row">
              {/* <div className="col-lg-6 col-md-6"> */}
                {/* single box item */}
                <div className="ca-iner-ch-box-content mb-40 mb-40-sec">
                  <h4 className="ca-title fnw-600 theme-black-2 pb-16">
                    Our Vision
                  </h4>
                  <p>
                    To be recognized as the foremost and most trusted supplier of copper piping and fittings in the trading sector, continually leveraging our expertise to enhance supply chain efficiency and product accessibility for our clients across the market.
                  </p>
                </div>
              {/* </div> */}
              {/* <div className="col-lg-6 col-md-6"> */}
                {/* single box item */}
                <div className="ca-iner-ch-box-content mb-40 mb-40-sec">
                  <h4 className="ca-title fnw-600 theme-black-2 pb-16">
                    Our Commitment
                  </h4>
                  <p>
                    Driven by the spirit of 'Karmyogi'—the dedication to diligent and selfless action—we are committed to three core principles.
                  </p>
                </div>
              {/* </div> */}
               {/* <div className="col-lg-6 col-md-6"> */}
                {/* single box item */}
                <div className="ca-iner-ch-box-content mb-40 mb-40-sec">
                  <h4 className="ca-title fnw-600 theme-black-2 pb-16">
                    Quality Assurance
                  </h4>
                  <p>
                    Supplying only materials that offer durability, precision, and optimal performance.Ensuring timely delivery and consistent product availability to prevent project delays.
                  </p>
                </div>
              {/* </div> */}
            </div>
            {/* <div className="ca-about-3-btn">
              <a
                href="#"
                className="ca-btn-primary-3 theme-bg-3 text-white br-50"
              >
                Learn More
                <span>
                  <i className="fa-solid fa-angle-right" />
                </span>
              </a>
            </div> */}
          </div>
        </div>
        <div className="col-lg-6 mb-30 hide-m">
          <div className="ca-choose-img p-relative z-index-1">
            <img
              className="w-100 wow img-custom-anim-left"
              data-wow-duration="1.5s"
              data-wow-delay=".2s"
              src="/static/img/about/ca-choose-ing1.1.webp"
              alt=""
            />
            <div className="ca-ch-butom-img p-absolute">
              <img
                className="w-100 wow img-custom-anim-left"
                data-wow-duration="1.5s"
                data-wow-delay=".3s"
                src="/static/img/about/ca-ch-2.webp"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* choose section end */}
  {/* valus section start */}
  <section className="ca-about-3 pt-100 pb-70">
    <div className="container">
      <div className="row flex-column-reverse flex-lg-row">
        <div className="col-lg-6 mb-30">
          <div
            className="ca-value-img mr-50 wow img-custom-anim-left"
            data-wow-duration="1.5s"
            data-wow-delay=".3s"
          >
            <img
              className="w-100 br-7"
              src="/static/img/about/ca-value1.1.webp"
              alt=""
            />
          </div>
        </div>
        <div className="col-lg-6 mb-30">
          <div className="ca-value-content3">
            <div className="ca-about-content-3 ca-sec-content-3">
              <h5 className="ca-section-subtitle subtitle-bg-6 p-relative theme-color-3 br-50">
                Our Values
              </h5>
              <h2 className="ca-section-title theme-black-3 fnw-600 pt-16 ca-text-cap">
                What Makes Us Different?
              </h2>
              <p className="pt-16 pb-40">
                We believe that unity and teamwork are the key drivers for growth and development.
              </p>
            </div>
            <div className="row">
              <div className="col-lg-6 col-md-6 mb-20">
                <div className="ca-value-cbox w-bg text-center br-7">
                  <h3 className="ca-counter-title theme-black-3 fnw-700 pb-16">
                    <span className="counter">10</span>
                  </h3>
                  <span className="v-text">Years of experience</span>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 mb-20">
                <div className="ca-value-cbox w-bg text-center br-7">
                  <h3 className="ca-counter-title fnw-700 pb-16">
                    <span className="counter">1000</span>+
                  </h3>
                  <span className="v-text">Customers Globally</span>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 mb-20">
                <div className="ca-value-cbox w-bg text-center br-7">
                  <h3 className="ca-counter-title theme-black-3 fnw-700 pb-16">
                    <span className="counter">100</span>+
                  </h3>
                  <span className="v-text">Product Range</span>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 mb-20">
                <div className="ca-value-cbox w-bg text-center br-7">
                  <h3 className="ca-counter-title fnw-700 pb-16">
                    <span className="counter">150</span>+
                  </h3>
                  <span className="v-text">5 Star Reviews</span>
                </div>
              </div>
            </div>
            {/* <div className="ca-about-3-btn">
              <a
                href="#"
                className="ca-btn-primary-3 theme-bg-3 text-white br-50 mt-12"
              >
                Learn More
                <span>
                  <i className="fa-solid fa-angle-right" />
                </span>
              </a>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  </section>
  {/* valus section end */}
  {/* team section start */}
  {/* <div className="ca-team-iner pt-100 pb-70">
    <div className="container"> */}
      {/* <div
        className="ca-team-iner-content-3 ca-sec-content-3 text-center mb-60 wow tpFadeInUp"
        data-wow-duration="1.5s"
        data-wow-delay=".2s"
      >
        <h5 className="ca-section-subtitle subtitle-bg-6 p-relative theme-color-3 br-50">
          Our Team
        </h5>
        <h2 className="ca-section-title theme-black-3 fnw-600 pt-16 ca-text-cap">
          The People Behind Our Success
        </h2>
        <p className="pt-16">
          Each member brings a wealth of knowledge and expertise, ensuring that
          we deliver
          <br />
          top-notch transport and logistics solutions to our clients.
        </p>
      </div> */}
      {/* <div className="row"> */}
        {/* single team item */}
        {/* <div className="col-lg-3 col-md-6 mb-30">
          <div
            className="ca-team-inner p-relative z-index-1 wow tpFadeInUp"
            data-wow-duration="1.5s"
            data-wow-delay=".2s"
          >
            <div className="ca-team-inner-content p-relative fix">
              <div className="ca-team-iner-img">
                <img
                  className="w-100"
                  src="/static/img/team/ca-team-iner1.1.webp"
                  alt=""
                />
              </div>
              <div className="ca-team-iner-social">
                <ul>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fa-brands fa-x-twitter" />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fa-brands fa-linkedin-in" />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fa-brands fa-instagram" />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fa-brands fa-facebook-f" />
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="ca-iner-content-team">
              <div className="ca-team-iner-content br-7">
                <div className="ca-team-iner-heading">
                  <h4 className="ca-team-iner-title">
                    <a href="/team">Alex Fargusion</a>
                  </h4>
                  <span>Specialist</span>
                </div>
                <div className="ca-team-iner-share">
                  <a href="#">
                    <img
                      src="/static/img/icon/ca-share.svg"
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* single team item */}
        {/* <div className="col-lg-3 col-md-6 mb-30">
          <div
            className="ca-team-inner p-relative z-index-1 wow tpFadeInUp"
            data-wow-duration="1.5s"
            data-wow-delay=".4s"
          >
            <div className="ca-team-inner-content p-relative fix">
              <div className="ca-team-iner-img">
                <img
                  className="w-100"
                  src="/static/img/team/ca-team-iner1.2.webp"
                  alt=""
                />
              </div>
              <div className="ca-team-iner-social">
                <ul>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fa-brands fa-x-twitter" />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fa-brands fa-linkedin-in" />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fa-brands fa-instagram" />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fa-brands fa-facebook-f" />
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="ca-iner-content-team">
              <div className="ca-team-iner-content br-7">
                <div className="ca-team-iner-heading">
                  <h4 className="ca-team-iner-title">
                    <a href="/team">Richad Stones</a>
                  </h4>
                  <span>Ceo &amp;Founder</span>
                </div>
                <div className="ca-team-iner-share">
                  <a href="#">
                    <img
                      src="/static/img/icon/ca-share.svg"
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* single team item */}
        {/* <div className="col-lg-3 col-md-6 mb-30">
          <div
            className="ca-team-inner p-relative z-index-1 wow tpFadeInUp"
            data-wow-duration="1.5s"
            data-wow-delay=".6s"
          >
            <div className="ca-team-inner-content p-relative fix">
              <div className="ca-team-iner-img">
                <img
                  className="w-100"
                  src="/static/img/team/ca-team-iner1.3.webp"
                  alt=""
                />
              </div>
              <div className="ca-team-iner-social">
                <ul>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fa-brands fa-x-twitter" />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fa-brands fa-linkedin-in" />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fa-brands fa-instagram" />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fa-brands fa-facebook-f" />
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="ca-iner-content-team">
              <div className="ca-team-iner-content br-7">
                <div className="ca-team-iner-heading">
                  <h4 className="ca-team-iner-title">
                    <a href="/team">Pep Gurdiola</a>
                  </h4>
                  <span>Manager</span>
                </div>
                <div className="ca-team-iner-share">
                  <a href="#">
                    <img
                      src="/static/img/icon/ca-share.svg"
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        {/* single team item */}
        {/* <div className="col-lg-3 col-md-6 mb-30">
          <div
            className="ca-team-inner p-relative z-index-1 wow tpFadeInUp"
            data-wow-duration="1.5s"
            data-wow-delay=".8s"
          >
            <div className="ca-team-inner-content p-relative fix">
              <div className="ca-team-iner-img">
                <img
                  className="w-100"
                  src="/static/img/team/ca-team-iner1.4.webp"
                  alt=""
                />
              </div>
              <div className="ca-team-iner-social">
                <ul>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fa-brands fa-x-twitter" />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fa-brands fa-linkedin-in" />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fa-brands fa-instagram" />
                      </span>
                    </a>
                  </li>
                  <li>
                    <a href="#">
                      <span>
                        <i className="fa-brands fa-facebook-f" />
                      </span>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
            <div className="ca-iner-content-team">
              <div className="ca-team-iner-content br-7">
                <div className="ca-team-iner-heading">
                  <h4 className="ca-team-iner-title">
                    <a href="/team">Alex Fargusion</a>
                  </h4>
                  <span>Coordinator</span>
                </div>
                <div className="ca-team-iner-share">
                  <a href="#">
                    <img
                      src="/static/img/icon/ca-share.svg"
                      alt=""
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      {/* </div> */}
    {/* </div>
  </div> */}
  {/* team section End */}
</main>
</>
  );
};

export default About;